// extracted by mini-css-extract-plugin
export default {"header":"SamlLink_header__VT7ra","titleImage":"SamlLink_titleImage__+ZLxk","secondaryInfo":"SamlLink_secondaryInfo__1CHNR","forgot":"SamlLink_forgot__W3Ejp"};